<template>
  <ontos-base v-bind="baseProps" phone-flush>
    <!-- O MESMO editor da janela (`PropertyEditor`): aqui ficam só as decisões da página — de onde vem o
         rascunho, o Voltar e para onde ir ao salvar -->
    <ontos-property-editor v-if="loaded" :idea="idea" :workspace="workspace" :property="property"
                           :identifier="identifier" :start="start" :saving="savingProperty" @save="save($event)">
      <template #controls="{dirty}">
        <ontos-header-action icon="mdi-arrow-left" :label="$tt('back')" @click="onBack(dirty)"/>
      </template>
    </ontos-property-editor>

    <!-- O mesmo aviso do X da janela: aqui a janela é a rota, então Voltar é navegar — mas a perda, para
         quem está digitando, é idêntica -->
    <ontos-unsaved-changes-dialog :leaving="leaving" @confirmed="goToDesign()" @cancelled="leaving = null"/>
  </ontos-base>
</template>
<script lang="ts">
import {Component, toNative} from 'vue-facing-decorator'
import IdeaLevelRouteComponent from '@/components/shared/IdeaLevelRouteComponent'
import UnsavedChangesDialog, {Leave} from '@/components/shared/UnsavedChangesDialog.vue'
import PropertyEditor, {PropertyResume} from '@/components/design/property/PropertyEditor.vue'
import IdeaProperty from '@/types/IdeaProperty'
import {PropertySave} from '@/types/PropertySave'
import {takeHandover} from '@/utils/handover'
import {propertyKey} from '@/utils/propertyLink'

/**
 * A página de uma propriedade — editar a gravada, ou criar uma na coleção —, para onde o Expandir da
 * janela leva (pedido do usuário). Vale sozinha também: pela URL ou no F5 a propriedade sai do ambiente
 * já carregado, sem ir ao servidor; e expandida, com o que estava na janela (`PropertyResume`).
 *
 * Ao salvar e ao voltar, o design da coleção, de onde a janela se abre.
 */
@Component({
  components: {
    'ontos-property-editor': PropertyEditor,
    'ontos-unsaved-changes-dialog': UnsavedChangesDialog
  }
})
class PropertyPage extends IdeaLevelRouteComponent {
  /** O que a janela deixou ao expandir, ou null. */
  start: PropertyResume | null = null
  /** Criar já no nome dos itens: vem da janela aberta pelo "+" da caixa — ver o `PropertyEditor`. */
  identifier = false
  savingProperty = false
  /** Saída esperando confirmação, ou null quando não há aviso na tela */
  leaving: Leave | null = null

  /** A propriedade da URL, ou undefined ao criar. */
  get property(): IdeaProperty | undefined {
    const alias = this.params.property
    return alias ? this.idea.properties.find(property => property.alias === alias) : undefined
  }

  async load() {
    //A coleção ou a propriedade que não existe — renomeada, excluída —: o design, que é de onde se vem
    if (!this.idea || (this.params.property && !this.property)) return this.goToDesign()
    const handed = takeHandover(propertyKey(this.params.system, this.params.idea, this.params.property))
    if (handed) {
      this.start = handed.resume
      this.identifier = handed.identifier
    }
  }

  async save(save: PropertySave) {
    this.savingProperty = true
    try {
      if (await this.savePropertyReporting(save, this.idea)) await this.goToDesign()
    } finally {
      this.savingProperty = false
    }
  }

  /** Desistiu: o design de volta, com o aviso quando há rascunho — como o X da janela. */
  onBack(dirty: boolean) {
    if (dirty) this.leaving = 'back'
    else this.goToDesign()
  }

  async goToDesign() {
    this.leaving = null
    await this.$router.push({name: 'view-idea', params: {system: this.params.system, idea: this.params.idea}})
  }
}

export default toNative(PropertyPage)
</script>
